import { Component, inject } from '@angular/core';
import { ExternalVideoDialogFacade } from 'src/app/_core/state/dialogs/external-video/external-video.facade';
import { toSignal } from '@angular/core/rxjs-interop';
import { ExternalVideoData } from 'src/app/_core/state/dialogs/external-video/model/external-video-data.model';

@Component({
  selector: 'opac-external-video-dialog',
  templateUrl: './external-video-dialog.component.html',
  styleUrls: ['./external-video-dialog.component.scss'],
})
export class ExternalVideoDialogComponent {
  private readonly externalVideoDialogFacade = inject(ExternalVideoDialogFacade);

  readonly externalVideoData = toSignal<ExternalVideoData>(this.externalVideoDialogFacade.externalVideoData$);
  readonly isOpen = toSignal<boolean>(this.externalVideoDialogFacade.open$);

  closeDialog() {
    this.externalVideoDialogFacade.closeDialog();
  }
}
